import React from "react";
import PrimaryButton from "../../common/Button/PrimaryButton";

const HomePageHeroSection = () => {
  return (
    <div className="px-6 lg:px-56 pt-32 pb-[40px] flex flex-col items-center justify-center gap-10 text-black">
      <h1 className="hidden">The best free photo collage maker.</h1>

      <div className="hidden md:block">
        <div className="flex flex-col items-center justify-center">
          <div className="font-bold text-8xl flex gap-3">
            <span>The best free</span>
            <GradientText text="photo" />
          </div>
          <div className="font-bold text-8xl flex gap-3 -mt-4">
            <GradientText text="collage" />
            <span>maker.</span>
          </div>
          <p className="text-center pt-2 flex flex-col">
            <span>Quickly make stunning photo collages. Get creative with</span>
            <span>backgrounds, texts, stickers, and doodles. Start with a</span>
            <span>grid or pick a template for any occasion.</span>
          </p>
        </div>
      </div>

      <div className="md:hidden block">
        <div className="flex flex-col items-center justify-center leading-tight">
          <div className="font-bold text-6xl">The best free</div>
          <div className="font-bold text-6xl">
            <GradientText text="photo collage" />
          </div>
          <div className="font-bold text-6xl">maker.</div>
          <p className="text-center pt-3 text-md">
            Quickly make stunning photo collages. Get creative with backgrounds,
            texts, stickers, and doodles. Start with a grid or pick a template
            for any occasion.
          </p>
        </div>
      </div>

      <PrimaryButton className="rounded-full" text="Make a Collage" />

      <video
        className="shadow-2xl rounded-lg w-full max-w-[944px]"
        autoPlay
        muted
        playsInline
        loop
        src="/static/videos/hero.mp4"
      ></video>
    </div>
  );
};

type GradientTextProps = {
  text: string;
};

const GradientText = ({ text }: GradientTextProps) => {
  return (
    <span className="bg-gradient-to-r from-light-orange to-dark-orange text-transparent bg-clip-text">
      {text}
    </span>
  );
};

export default HomePageHeroSection;
